module.exports = __webpack_public_path__ + "img/10.0ee6a297.jpg";